// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"4edab05a","239":"1b1b740f","453":"c0af5cf9","732":"10154dc8","977":"39ff5a99"}[chunkId] + ".chunk.js";
};